import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useContext } from 'react';
import { OverallDataContext, TabContext } from '../../pages/CalculatorPage';

export default function FormProgressBar({ tabNames }) {
    const [tabValue, setTabValue] = useContext(TabContext).tabValue;
    const isLoading = useContext(OverallDataContext).isLoading;
    
    return (
        <Grid2 container spacing={{ xs: 0, sm: 1 }} className="hide-on-print">
            <Grid2 xs={true} >
            { isLoading ?
                <Box sx={{ my: 2, color: 'var(--mcc-bg)' }} >
                    <LinearProgress color="inherit" />
                </Box>
                :
                <Stack direction='row'
                    sx={{ 
                        justifyContent: 'center', 
                        py: 2, 
                        overflow: 'auto' 
                    }}
                >
                    {
                        Object.keys(tabNames).map((tabIndex) => {
                            return (
                                <Box
                                    key={tabIndex}
                                    onClick={()=>setTabValue(parseInt(tabIndex))}
                                    sx={{
                                        backgroundColor: parseInt(tabIndex)<=tabValue ? 'var(--mcc-bg)' : 'white',
                                        width: `${100/Object.keys(tabNames).length}%`,
                                        height: 4,
                                        '&:hover' : {
                                            backgroundColor: parseInt(tabIndex)!==tabValue ? 'var(--mcc-contrast2)' : '',
                                            cursor: 'pointer',
                                        }
                                    }}
                                >
                                </Box>
                            )
                        })
                    }
                </Stack>
            }
            </Grid2>
            <Grid2 
                xs={0} sm={'auto'} 
                sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', justifyContent: 'end', textAlign: 'end' }}
            >
                <Typography variant="caption" color="text.secondary">
                    { tabNames[tabValue] }
                </Typography>
            </Grid2>
        </Grid2>
    )
}